/*
Documentation

This page shows all appointment templates within the system
Appointment templates are stored in redux so no db call is needed here

*/

import NotificationDelete from 'components/functional/notifications/Delete';
import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Container, CardTitle } from "reactstrap";

const { SearchBar } = Search;

class AppointmentTemplatesAll extends React.Component {

    state = {}

    columns = [
        {
            dataField: "name",
            text: "Name",
            formatter: (cell, row) => (
                <Link to={`/core/appointments/templates/${row._id}`}> {row.name} </Link>
            )
        },
        {
            dataField: "division",
            text: "Division",
            formatter: (cell, row) => {
                const division = this.props.divisions.find(d => d._id === row.division);
                return division ? division.name : '';
            }
        },
        {
            dataField: "type",
            text: "Appointment Type",
            formatter: (cell, row) => (
                <span className="text-capitalize">{row.type}</span>
            )
        },
        {
            dataField: "questionnaire",
            text: "Questionnaire",
            formatter: (cell, row) => row.questionnaire ? row.questionnaire.name : "-"
        },
        {
            dataField: "assigned_to",
            text: "Assigned To",
            formatter: (cell, row) => row.assigned_to ? row.assigned_to.length + ' users' : 0 + ' Users'
        },
        {
            dataField: "x",
            text: "Actions",
            headerStyle: {textAlign: 'right'},
            formatter: (cell, row) => {
                return (
                    <div className="text-right">
                        <Link to={`/core/appointments/templates/${row._id}`}><i className="fas fa-edit text-success mr-2"></i></Link>
                        <i onClick={() => this.setState({appTemplateToDelete: row})} className="fas fa-trash text-danger"></i>
                    </div>
                )
            }
        },
    ]

    pagination = paginationFactory({
        page: 1,
        alwaysShowAllBtns: true,
        showTotal: false,
        sizePerPage: 25,
        withFirstAndLast: false,
        sizePerPageRenderer: () => false
    });

    render() {

        const template_appointments = this.props.template_appointments;
        const appointmentTemplateLength = this.props.template_appointments.template_appointments.length;
        const appTemplateToDelete = this.state.appTemplateToDelete;

        return (
            <>

            {appTemplateToDelete && (
                <NotificationDelete
                    deletionURL={`/api/v1/core/template_appointments/delete/${appTemplateToDelete._id}`}
                    confirmBtnText="Delete Template"
                    title={`Delete ${appTemplateToDelete.name}`}
                    text="Deleting this template appointment will make all automations calling this template cease to work until their template is changed."
                    onClose={() => this.setState({appTemplateToDelete: null})}
                    onSuccess={() => {} }
                />
            )}

            <Container fluid>

                <Helmet>
                    <title>{`Appointment Templates (${appointmentTemplateLength}) `}</title>
                    <meta name="description" content="Appointment Templates" />
                </Helmet>

                <DashHeaderOpen
                    title={<span><i className="fas fa-database mr-2 text-success " /> System</span>}
                    breadcrumb_1="Appointment Templates"
                    breadcrumb_2="All"
                    actionComponent={(
                        <Link className="btn btn-success" to="/core/appointments/templates/new"><i className="fas fa-plus mr-2" />Add</Link>
                    )}
                />

                <Card>

                    <CardHeader>
                        <CardTitle className="mb-0">All Appointment Templates</CardTitle>
                    </CardHeader>

                    {template_appointments.total ? (

                        <ToolkitProvider
                            data={template_appointments.template_appointments}
                            keyField="_id"
                            columns={this.columns}
                            search
                        >
                            {props => (
                                <>
                                    <div className="dataTables_filter px-4 pb pt-3 pb-2" >
                                        <label>
                                            Search:
                                            <SearchBar
                                                className="form-control-sm"
                                                placeholder="Template Name"
                                                {...props.searchProps}
                                            />
                                        </label>
                                    </div>

                                    <div className=" table-responsive table-vertical-align">
                                        <BootstrapTable
                                            pagination={this.pagination}
                                            {...props.baseProps}
                                            bootstrap4={true}
                                            bordered={false}
                                        />
                                    </div>
                                </>
                            )}
                        </ToolkitProvider>

                    ) : (

                        <CardBody>

                            No appointment templates have been created yet.

                            <Link to="/core/appointments/templates/new">
                                <b className="text-warning"> Click here to create one.</b>
                            </Link>

                        </CardBody>

                    )}
                </Card>

            </Container>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        divisions: state.divisions.divisions,
        template_appointments: state.template_appointments
    };
};

export default connect(mapStateToProps, '')(AppointmentTemplatesAll);
